// NetPort over the browser's WebSocket + fetch. The sync WebSocket carries
// no token in the URL (auth is the first frame — protocol spec §lifecycle),
// so no cookie/CSRF concerns apply to it; REST goes through the CSRF-aware
// ApiClient. Node ≥22 provides the same WebSocket/fetch globals, so the
// integration harness reuses this module verbatim against the real server.

import { WS_SUBPROTOCOL, type NetPort, type SyncSocket } from "@cairn/core";
import { ApiClient } from "./api";

function wrapSocket(ws: WebSocket): SyncSocket {
  ws.binaryType = "arraybuffer";
  return {
    send: (frame) => ws.send(frame),
    protocol: () => ws.protocol,
    onOpen: (cb) => ws.addEventListener("open", () => cb()),
    onMessage: (cb) =>
      ws.addEventListener("message", (ev: MessageEvent) => {
        if (ev.data instanceof ArrayBuffer) cb(new Uint8Array(ev.data));
      }),
    onClose: (cb) =>
      ws.addEventListener("close", (ev: CloseEvent) =>
        cb({ code: ev.code, reason: ev.reason }),
      ),
    close: (code?: number, reason?: string) => ws.close(code, reason),
  };
}

/** Build the viewer's NetPort from an ApiClient (shares base + headers). */
export function makeNet(api: ApiClient): NetPort {
  return {
    connect: (wsUrl: string) => wrapSocket(new WebSocket(wsUrl, [WS_SUBPROTOCOL])),
    http: api.asHttpClient(),
  };
}
